function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgArrowUp = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 33,
  height: 32,
  viewBox: "0 0 33 32",
  fill: "none"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M18.3865 10.3435H10.844M10.844 10.3435V17.886M10.844 10.3435L22.1577 21.6572",
  stroke: props.stroke,
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));
export default SvgArrowUp;